<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card-widget title="Informações">
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col
                v-if="nome !== ''"
                cols="6"
              >
                <span class="font-weight-bold">Usuário(a): </span>
                <span class="font-weight-light">{{ nome }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-widget
          :title="titulo ? titulo : 'Informações'"
          enable-actions
        >
          <div slot="widget-content">
            <v-row>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    absolute
                    color="secondary"
                    dark
                    fab
                    right
                    top
                    @click="loadTutorial"
                    v-on="on"
                  >
                    <v-icon>help</v-icon>
                  </v-btn>
                </template>
                <span>Em caso de dúvidas, clique aqui</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    absolute
                    class="mr-16"
                    color="secondary"
                    dark
                    fab
                    right
                    top
                    @click="visualizarTermoResponsabilidade"
                    v-on="on"
                  >
                    <v-icon>description</v-icon>
                  </v-btn>
                </template>
                <span>Para visualizar o termo de responsabilidade novamente, clique
                  aqui</span>
              </v-tooltip>
            </v-row>
            <slot name="body" />
          </div>
          <div slot="widget-actions">
            <v-row no-gutters>
              <v-col cols="12">
                <!-- Slot Actions-->
                <slot name="actions" />
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>

    <dialog-termo-responsabilidade
      :dialog-props="dialogs.dialogTermoResponsabilidade"
    />
  </div>
</template>

<script>
import VCardWidget from '@/components/VWidget';
import DialogTermoResponsabilidade from '@/components/perfil/DialogTermoResponsabilidade';

export default {
  name: 'AppPerfil',

  components: { VCardWidget, DialogTermoResponsabilidade },

  props: {
    titulo: {
      type: String,
      default: '',
    },
    nome: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialogs: {
        dialogTermoResponsabilidade: {
          visibilidade: false,
          dialogAceitar: false,
          dialogVisualizar: true,
        },
      },
    };
  },

  methods: {
    loadTutorial() {
      this.$store.dispatch('app/showTutorial', { nome: 'Perfil' });
    },
    visualizarTermoResponsabilidade() {
      this.dialogs.dialogTermoResponsabilidade.visibilidade = true;
    },
  },
};
</script>
